import Marquee from "react-fast-marquee";

const WORDS = [
  "Brands worth building",
  "Strategy",
  "Craft",
  "Positioning",
  "Identity",
  "Six to eight projects a year",
  "Naming",
  "Growth advisory",
];

export default function EditorialMarquee() {
  return (
    <section
      className="relative border-y border-charcoal/20 bg-ivory overflow-hidden"
      data-testid="editorial-marquee"
      aria-hidden
    >
      <Marquee gradient={false} speed={22} pauseOnHover={false} play autoFill>
        {WORDS.map((w, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-10 pr-10 py-8 md:py-12 font-display text-6xl md:text-8xl leading-none tracking-tightest text-charcoal"
          >
            {w}
            <span className="inline-block h-2 w-2 rounded-full bg-charcoal/70 align-middle" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
